import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import contacts_img_1 from '../img/contacts/contacts-1.svg'

import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Contacts extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask');
	    mask.addEventListener('touchstart', this.pageClick, false);
	}

	render() {
		return (
			<div>

				<Helmet
					title="Contact with remote academic writers agency - UvoCorp.com"
					meta={[
						{ name: "description", content: "Freelance academic writing agency contacts." },

						{ property: 'og:title', content: "Contact with remote academic writers agency - UvoCorp.com" },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:description', content: "Freelance academic writing agency contacts." },
						{ property: 'og:image', content: ogp_cover },

					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/contacts.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">

					<div className="inner-header">
						<div className="container">
							<h1>Contacts</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="inner-white inner-center contacts-block">
						<div className="container">
							<div className="col-sm-7 col-md-8">

								<h2 className="left">Our contact information</h2>

								<dl className="contacts-list">
									<dt>Telephone numbers:</dt>
									<dd><a href="tel:+18667197923">1 866 719 7923</a></dd>

									<dt>Working hours:</dt>
									<dd>Monday 00:00 – Saturday 12:00 PM (GMT)</dd>
								</dl>

								<p>If you have any questions or suggestions, please, contact us through <a href="mailto:vacancy@uvocorp.com">vacancy@uvocorp.com</a></p>
							</div>
							<div className="col-sm-5 col-md-4">
								<div className="contacts_img contacts_img_1">
									<img src={contacts_img_1} alt="Contacts Image1"/>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>


					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/contacts.html.js